import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { LoginComponent } from './auth-layout/pages/login/login.component';
import { SignupComponent } from './auth-layout/pages/signup/signup.component';
import { ForgotPasswordComponent } from './auth-layout/pages/forgot-password/forgot-password.component';

import { P419ErrorComponent } from './errors/419.component';
import { P500ErrorComponent } from './errors/500.component';
import { P404ErrorComponent } from './errors/404.component';

import { CoachGuard } from './guards/coach.guard';
import { GuestGuard } from './guards/guest.guard';
import { SchoolGuard } from './guards/school.guard';
import { SchoolDashboardLayoutComponent } from './school-dashboard-layout/school-dashboard-layout.component';

const routes: Routes = [
    {
        path: '',
        component: HomeLayoutComponent,
        loadChildren: () => import('./home-layout/home-layout.module').then((m) => m.HomeLayoutModule),
    },

    {
        path: '',
        canActivate: [CoachGuard],
        component: DashboardLayoutComponent,
        loadChildren: () => import('./dashboard-layout/dashboard-layout.module').then((m) => m.DashboardLayoutModule),
    },
   
    {
        path: 'school',
        canActivate: [SchoolGuard],
        component: SchoolDashboardLayoutComponent,
        loadChildren: () => import('./school-dashboard-layout/school-dashboard-layout.module').then((m) => m.SchoolDashboardLayoutModule),
    },

    { path: 'login', component: LoginComponent, canActivate: [GuestGuard], data: { pageTitle: 'Login' } },
    { path: 'signup', component: SignupComponent, canActivate: [GuestGuard], data: { pageTitle: 'Signup' } },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [GuestGuard], data: { pageTitle: 'Reset Password' } },

    { path: 'error/419', component: P419ErrorComponent, data: { pageTitle: 'Page Expired' } },
    { path: 'error/500', component: P500ErrorComponent, data: { pageTitle: 'Server Error' } },
    { path: 'error/404', component: P404ErrorComponent, data: { pageTitle: 'Not Found' } },
    { path: '**', component: P404ErrorComponent, data: { pageTitle: 'Not Found' } }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
